export async function createCredential(
  decodedOptions: PublicKeyCredentialCreationOptions
): Promise<(PublicKeyCredential & { response: AuthenticatorAttestationResponse }) | undefined> {
  // Create the credential.
  // We know that this credential has a PublicKeyCredential type with a AuthenticatorAttestationResponse
  // because we're creating it over a secure connection in supported browsers.
  // PublicKeyCredential: https://developer.mozilla.org/en-US/docs/Web/API/PublicKeyCredential
  // AuthenticatorAttestationResponse: https://developer.mozilla.org/en-US/docs/Web/API/AuthenticatorAttestationResponse)
  const credential = (await navigator.credentials.create({
    publicKey: decodedOptions,
  })) as (PublicKeyCredential & { response: AuthenticatorAttestationResponse }) | undefined

  // TODO (in later PR): Handle non-happy paths
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return credential
}
